var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "rootRef", staticClass: "proofreading-category-accordion" },
    [
      _c(
        "div",
        {
          staticClass: "proofreading-category-accordion__header",
          class: {
            "proofreading-category-accordion__header--open": _setup.isOpen,
            "proofreading-category-accordion__header--has-leading":
              _setup.hasLeading,
          },
        },
        [
          _c(
            "div",
            { staticClass: "proofreading-category-accordion__header__inner" },
            [
              _setup.hasLeading
                ? _c(
                    "div",
                    { staticClass: "proofreading-category-accordion__leading" },
                    [_vm._t("header-leading")],
                    2
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "proofreading-category-accordion__toggle",
                  attrs: { type: "button", "aria-expanded": _setup.isOpen },
                  on: { click: _setup.toggle },
                },
                [
                  _vm._t("header", function () {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "proofreading-category-accordion__label",
                        },
                        [_vm._v(_vm._s(_vm.label))]
                      ),
                    ]
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "proofreading-category-accordion__chevron",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v("⌃")]
                  ),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "proofreading-category-accordion__content",
          class: {
            "proofreading-category-accordion__content--open": _setup.isOpen,
          },
          attrs: { "aria-hidden": !_setup.isOpen },
        },
        [
          _c(
            "ul",
            { staticClass: "proofreading-category-accordion__list" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }